import { useEffect, useRef, useState } from 'react';

const ExpandableText = ({ text }: { text: string }) => {
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowing(
        textRef.current.scrollHeight > textRef.current.clientHeight
      );
    }
  }, [text]);

  return (
    <div>
      <p className="whiteSpace-preLine printMedia printShow word-break-all">
        {text}
      </p>
      <p
        ref={textRef}
        style={{
          display: '-webkit-box',
          WebkitLineClamp: expanded ? 'unset' : 3,
          WebkitBoxOrient: 'vertical',
        }}
        className="whiteSpace-preLine overflow-hidden printHide"
      >
        {text}
      </p>
      {(isOverflowing || expanded) && (
        <span
          onClick={() => setExpanded(!expanded)}
          className="cursor-pointer buttonText font-bold hover:underline printHide"
        >
          {expanded ? 'Show less' : 'Show more'}
        </span>
      )}
    </div>
  );
};

export default ExpandableText;
